module.exports = __webpack_public_path__ + "static/media/ic_收起1.ac2b06bc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_收起1.svg
// module id = 243
// module chunks = 0